import { render, staticRenderFns } from "./SoftwareRuntimeManager.vue?vue&type=template&id=3cc31584&scoped=true&"
import script from "./SoftwareRuntimeManager.vue?vue&type=script&lang=js&"
export * from "./SoftwareRuntimeManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc31584",
  null
  
)

export default component.exports